<template>
	<div>
		<!-- Winner Bracket -->
		<Card class="winner-bracket-block tournament-stage table-card-style pb-4">
			<h3 class="my-4">Winner Bracket</h3>
			<div class="winner-table-block">
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 1)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 2)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table :key="match._id" class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 2.5)"
							:key="match._id"
							class="tournament-stage table-card-style loose-background looser-position w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											3rd-4th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name ? match.home_team.name : match.home_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name ? match.home_team.name : match.home_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>

						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 3)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table :key="match._id" class="match-table">
								<tbody>
									<tr>
										<td>
											Final
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name ? match.home_team.name : match.home_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name ? match.home_team.name : match.home_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
			</div>
			<div class="loosers-table-block">
				<hr class="mt-5 mb-5" />
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 0.5)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>

					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 1.25)"
							:key="match._id"
							class="tournament-stage table-card-style loose-background looser-position w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											7th-8th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === 1.5)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											5th-6th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
			</div>
		</Card>

		<!-- Consolation Bracket -->
		<Card v-if="this.single.some(({ playoffStage }) => playoffStage < 0)" class="tournament-stage table-card-style pb-4 mt-4">
			<h3 v-if="this.single.some(({ playoffStage }) => playoffStage < 0)" class="my-4">Consolation Bracket</h3>
			<div class="winner-table-block">
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -1)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>

					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -2)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>

					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -2.5)"
							:key="match._id"
							class="tournament-stage table-card-style loose-background mb-3 looser-position w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											11th-12th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name ? match.home_team.name : match.home_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name ? match.home_team.name : match.home_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -3)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											9th-10th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name ? match.home_team.name : match.home_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name ? match.home_team.name : match.home_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">{{ getPoints(match.home_players, match, match.home_team) }} </span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">{{ getPoints(match.away_players, match, match.away_team) }} </span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
			</div>

			<div class="loosers-table-block">
				<hr class="mt-5 mb-5" />
				<Row :gutter="16" class="d-flex flex-column">
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -0.5)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
					<Col class="d-flex justify-content-around w-100">
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -1.25)"
							:key="match._id"
							class="tournament-stage table-card-style loose-background looser-position mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											15th-16th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
						<Card
							v-for="match in single.filter(({ playoffStage }) => playoffStage === -1.5)"
							:key="match._id"
							class="tournament-stage table-card-style mb-3 w-24procent"
						>
							<table class="match-table">
								<tbody>
									<tr>
										<td>
											13th-14th Place Match
										</td>
										<td class="w-70px"></td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) > getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.home_team.name" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.home_team.name }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px position-relative">
											<span v-if="matches.length">
												{{ getPoints(match.home_players, match, match.home_team) }}
											</span>
											<Icon role="button" type="md-information-circle" class="icon-pos" @click="() => openPlayoffModal(match, single)" />
										</td>
									</tr>
									<tr
										:class="`${
											getPoints(match.home_players, match, match.home_team) < getPoints(match.away_players, match, match.away_team) ? 'font-weight-bold ' : ''
										}`"
									>
										<td>
											<Tooltip v-if="matches.length" :content="match.away_team.name ? match.away_team.name : match.away_team" placement="top-start" class="w-100">
												<span class="text-overflow-style single-groups-clamp-text">
													{{ match.away_team.name ? match.away_team.name : match.away_team }}
												</span>
											</Tooltip>
										</td>
										<td class="w-70px">
											<span v-if="matches.length">
												{{ getPoints(match.away_players, match, match.away_team) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</Card>
					</Col>
				</Row>
			</div>
		</Card>
	</div>
</template>

<script>
	import storeMixin from '../storeMixin';
	export default {
		name: 'Single4Groups',
		data() {
			return storeMixin;
		},
	};
</script>

<style scoped>
	.loose-background {
		background-color: #ffddd4 !important;
	}

	.looser-position {
		position: absolute;
		top: 0;
		left: 100px;
		height: inherit;
	}

	.w-24procent {
		/* width: 275px; */
		width: 24%;
	}

	.w-12procent {
		/* width: 275px; */
		width: 12%;
	}

	.single-groups-clamp-text {
		width: 100%;
	}

	table {
		table-layout: fixed;
	}

	.w-70px {
		width: 70px;
		min-width: 70px;
	}

	.special-position-block {
		justify-content: space-evenly !important;
	}
</style>



// WEBPACK FOOTER //
// src/components/competitions/schemes/formats/groups/Single4Groups.vue